import { useEffect } from 'react'

export default function useMeta({ title, description, ogTitle, ogDescription, ogImage, canonicalUrl, lang = 'da' }) {
  useEffect(() => {
    // Set document title
    if (title) {
      document.title = title
    }

    // Set html lang attribute
    document.documentElement.setAttribute('lang', lang)

    // Helper to set or create meta tags
    const setMetaTag = (name, content, isProperty = false) => {
      if (!content) return
      const attributeName = isProperty ? 'property' : 'name'
      let element = document.querySelector(`meta[${attributeName}="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attributeName, name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    // Set description
    setMetaTag('description', description)

    // Set Open Graph tags
    setMetaTag('og:title', ogTitle || title, true)
    setMetaTag('og:description', ogDescription || description, true)
    setMetaTag('og:image', ogImage, true)
    setMetaTag('twitter:card', 'summary_large_image')
    setMetaTag('twitter:title', ogTitle || title)
    setMetaTag('twitter:description', ogDescription || description)
    setMetaTag('twitter:image', ogImage)

    // Set Canonical link
    if (canonicalUrl) {
      let linkElement = document.querySelector('link[rel="canonical"]')
      if (!linkElement) {
        linkElement = document.createElement('link')
        linkElement.setAttribute('rel', 'canonical')
        document.head.appendChild(linkElement)
      }
      linkElement.setAttribute('href', canonicalUrl)
    }
  }, [title, description, ogTitle, ogDescription, ogImage, canonicalUrl, lang])
}
